import { useEffect, useState } from "react";

/**
 * greenbook's desktop trade-desk layouts gate behind Tailwind's `lg` (≥1024px). Everything
 * below that is the simplified mobile/tablet experience. Prefer Tailwind responsive classes
 * (`lg:` etc.) for layout; use this hook ONLY when the DOM structure must differ (e.g. the
 * trade ticket becomes a bottom sheet instead of a right rail) rather than just restyle.
 */
export const MOBILE_MAX = 1023; // px — one below Tailwind's `lg` (1024)

export function useIsMobile(): boolean {
  const query = `(max-width: ${MOBILE_MAX}px)`;
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return isMobile;
}

/** Wide desktop (≥1280px): the game page adds its insight column here. */
export const WIDE_MIN = 1280;

export function useIsWide(): boolean {
  const query = `(min-width: ${WIDE_MIN}px)`;
  const [wide, setWide] = useState<boolean>(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setWide(e.matches);
    mql.addEventListener("change", onChange);
    setWide(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return wide;
}
